var ReadMore = {
    init:function(){
        
        document.querySelectorAll(".read-more-container").forEach(function(item){
            item.querySelector(".btn-read-more--more").addEventListener("click", function(){
                ReadMore.open_read_more(item);
            })
            item.querySelector(".btn-read-more--less").addEventListener("click", function(){
                ReadMore.close_read_more(item);
            })
        }) 

        window.addEventListener("resize", function(){
            ReadMore.resize();
        })
        ReadMore.resize();
    },
    open_read_more:function(item){
        item.classList.add("open");        
        var _h_dest = item.querySelector(".read-more__content-open").offsetHeight;

        item.querySelector(".read-more__mask").style.height = _h_dest + "px";
    },
    close_read_more:function(item){
        item.classList.remove("open");
        var _h_dest = item.querySelector(".read-more__content-close").offsetHeight;
        item.querySelector(".read-more__mask").style.height = _h_dest + "px";
    },
    resize:function(){
        /*
        document.querySelectorAll(".read-more-container").forEach(function(item){
            var _h_close = item.querySelector(".read-more__content-close").offsetHeight;
            var _h_open = item.querySelector(".read-more__content-open").offsetHeight;

            if(_h_open > _h_close){
                item.classList.remove("inactif");
                item.querySelector(".read-more__mask").style.height = _h_close + "px";
            }else{
                item.classList.add("inactif");
            }
        });
        */
    }
}

window.addEventListener("load", function(){
    if(document.querySelectorAll(".read-more-container").length > 0){
        ReadMore.init();
    }
})